import request from '@/util/request';

/**
 * 获取项目列表
 * @param {Object} params - 查询参数
 * @returns {Promise} API响应
 */
export const projectList = (params) => {
    return request.get('/project/list', { params });
};

/**
 * 管理员获取项目列表
 * @param {Object} params - 查询参数
 * @returns {Promise} API响应
 */
export const projectListAdmin = (params) => {
    return request.get('/project/listAdmin', { params });
};

/**
 * 新增项目
 * @param {Object} params - 项目数据
 * @returns {Promise} API响应
 */
export const projectAdd = (params) => {
    return request.post('/project/add', params);
};

/**
 * 更新项目
 * @param {Object} params - 项目数据
 * @returns {Promise} API响应
 */
export const projectUpdate = (params) => {
    return request.post('/project/update', params);
};

/**
 * 删除项目
 * @param {number} uuid - 项目UUID
 * @returns {Promise} API响应
 */
export const projectDelete = (uuid) => {
    return request.post('/project/delete?uuid='+uuid);
};

/**
 * 导入项目数据
 * @param {Object} params - 导入参数
 * @param {Boolean} params.skipHeader - 是否跳过表头
 * @param {File} params.importFile - 导入文件
 * @param {File} params.importFiledb - 导入数据库文件
 * @param {Boolean} params.user - 是否为管理员用户
 * @param {Integer} params.choose - 选择类型
 * @returns {Promise} API响应
 */
export const projectImport = (params) => {
    const formData = new FormData();
    
    // 添加基本参数
    formData.append('skipHeader', params.skipHeader);
    formData.append('user', params.user);
    formData.append('choose', params.choose);
    
    // 添加文件参数（如果存在）
    if (params.importFile) {
        formData.append('importFile', params.importFile);
    }
    if (params.importFiledb) {
        formData.append('importFiledb', params.importFiledb);
    }
    // 原逻辑保留（注释）：
    // if (params.importFile) {
    //     formData.append('importFile', params.importFile);
    // }
    // if (params.importFiledb) {
    //     formData.append('importFiledb', params.importFiledb);
    // }
    /**
     * 新增：可选添加图片ZIP文件
     * @param {File} params.importFileImgZIP - 图片资源ZIP压缩包（可选）
     */
    if (params.importFileImgZIP) {
        formData.append('importFileImgZIP', params.importFileImgZIP);
    }
    
    // 新增：根据 params.dbKey 设置请求头 db-key
    // 旧实现保留（注释）：
    // return request.post('/project/import', formData, {
    //     headers: {
    //         'Content-Type': 'multipart/form-data'
    //     }
    // });

    const headers = {
        'Content-Type': 'multipart/form-data'
    };
    if (params && params.dbKey) {
        headers['db-key'] = params.dbKey;
    }
    return request.post('/project/import', formData, { headers });
};

/**
 * 导出项目数据库文件
 * @param {string} compUuid - 单位编号
 * @returns {Promise} API响应 - 返回.db文件的二进制数据
 */
export const projectExport = (compUuid) => {
    return request.post('/project/exportByP', null, {
        params: {
            compUuid: compUuid
        },
        responseType: 'blob', // 重要：指定响应类型为blob以处理二进制文件
        headers: {
            'Accept': 'application/octet-stream'
        }
    });
};

// 获取用户绑定项目
export const projectGetUserBind = () => {
    return request.get('/project/getUserBind');
};

// 获取项目密钥
export const projectGetSecret = (compUuid) => {
    return request.get('/project/getSecret', {
        params: {
            compUuid: compUuid
        }
    });
};
